/**
 * @generated SignedSource<<d5011e9e2de7ceca52034423490cde12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type JiraAssigneeSelectionType = "ACCOUNT_OWNER" | "ACCOUNT_TAG" | "ACCOUNT_VARIABLE" | "EMAIL" | "RESOURCE_OWNER" | "RESOURCE_TAG" | "%future added value";
export type JiraSpaceSelectionType = "ACCOUNT_TAG" | "ACCOUNT_VARIABLE" | "RESOURCE_TAG" | "SPACE_KEY" | "%future added value";
export type AddNotificationRuleInput = {
  description?: string | null | undefined;
  filter: FilterElementInput;
  groupBy: ReadonlyArray<string>;
  includeCostData?: boolean | null | undefined;
  jiraTarget?: NotificationRuleJiraTargetInput | null | undefined;
  name: string;
  projectUUID: any;
  updateSchedule?: string | null | undefined;
};
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type NotificationRuleJiraTargetInput = {
  assignee?: JiraAssigneeSelectionInput | null | undefined;
  description?: string | null | undefined;
  instanceUUID: any;
  space: JiraSpaceSelectionInput;
  workType: string;
};
export type JiraSpaceSelectionInput = {
  type: JiraSpaceSelectionType;
  value: string;
};
export type JiraAssigneeSelectionInput = {
  type: JiraAssigneeSelectionType;
  value?: string | null | undefined;
};
export type AddNotificationRuleMutation$variables = {
  connections: ReadonlyArray<string>;
  input: AddNotificationRuleInput;
};
export type AddNotificationRuleMutation$data = {
  readonly addNotificationRule: {
    readonly notificationRule: {
      readonly description: string | null | undefined;
      readonly filterJSON: string;
      readonly groupBy: ReadonlyArray<string>;
      readonly id: string;
      readonly includeCostData: boolean;
      readonly name: string;
      readonly openGroupCount: number;
      readonly openResourceCount: number;
      readonly updateSchedule: string | null | undefined;
      readonly uuid: any;
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type AddNotificationRuleMutation = {
  response: AddNotificationRuleMutation$data;
  variables: AddNotificationRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "NotificationRule",
  "kind": "LinkedField",
  "name": "notificationRule",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterJSON",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeCostData",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "openGroupCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "openResourceCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updateSchedule",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddNotificationRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddNotificationRulePayload",
        "kind": "LinkedField",
        "name": "addNotificationRule",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddNotificationRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddNotificationRulePayload",
        "kind": "LinkedField",
        "name": "addNotificationRule",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "notificationRule",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "NotificationRuleEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "17a270ad8b002990514fd5af286eba65",
    "id": null,
    "metadata": {},
    "name": "AddNotificationRuleMutation",
    "operationKind": "mutation",
    "text": "mutation AddNotificationRuleMutation(\n  $input: AddNotificationRuleInput!\n) {\n  addNotificationRule(input: $input) {\n    notificationRule {\n      description\n      filterJSON\n      groupBy\n      id\n      includeCostData\n      name\n      openGroupCount\n      openResourceCount\n      updateSchedule\n      uuid\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a81ccb223d89888274fd1eeb55cfa68";

export default node;
